import { InputProps } from '@nextui-org/input';

const inputClasses: InputProps['classNames'] = {
  inputWrapper:
    'border-transparent bg-default-50/40 dark:bg-default-50/20 group-data-[focus=true]:border-foreground/20 data-[hover=true]:border-foreground/20',
};

export { inputClasses };
